module.exports = __webpack_public_path__ + "static/img/shareTop.2c0b315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/shareTop.png
// module id = ABJq
// module chunks = 1